import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormBalanceAdjustmentType from '../general-input-form/FormBalanceAdjustmentType'

const AppForm = ({
  form,
  values,
  handleChange,
  employeeOptions,
  handleSelectEmployee,
  handleSelectType,
  errors,
}) => {
  return (
    <>
      {form === 'create' && (
        <CRow className="mb-4">
          <FormSelectInput
            id='employee_id'
            name='employee_id'
            colSize='6'
            inputLabel='Selected Employee'
            className='mb-3'
            selectOptions={employeeOptions}
            value={employeeOptions?.find((option) => option.value === values.employee_id)}
            handleSelectInput={handleSelectEmployee}
            feedbackInvalid={errors.employee_id}
            invalid={errors.employee_id}
            disabled={false}
            placeholder='Please select employee...'
          />
          <FormTextInput
            id='initial_balance'
            name='initial_balance'
            colSize='6'
            inputLabel='Initial PTO Balance (Days)'
            className='mb-3'
            placeholder='Enter initial balance...'
            value={values.initial_balance}
            handleTextInput={handleChange}
            feedbackInvalid={errors.initial_balance}
            invalid={errors.initial_balance}
            type='number'
          />
        </CRow>
      )}
      {form === 'edit' && (
        <CRow className="mb-4">
          <FormSelectInput
            id='employee_id'
            name='employee_id'
            colSize='6'
            inputLabel='Selected Employee'
            className='mb-3'
            selectOptions={employeeOptions}
            value={employeeOptions?.find((option) => option.value === values.employee_id)}
            feedbackInvalid={errors.employee_id}
            invalid={errors.employee_id}
            disabled={true}
            placeholder='Please select employee...'
          />
          <FormBalanceAdjustmentType
            id='adjustment_type'
            type={'radio'}
            colSize={3}
            className='mb-3'
            inputLabel='Adjustment Type'
            value={values.adjustment_type}
            handleCheck={handleSelectType}
            disabled={false}
          />
          <FormTextInput
            id='days_amount'
            name='days_amount'
            colSize='6'
            inputLabel='Adjustment Balance (Days)'
            className='mb-3'
            placeholder='Enter adjustment balance...'
            value={values.days_amount}
            handleTextInput={handleChange}
            feedbackInvalid={errors.days_amount}
            invalid={errors.days_amount}
          />
          <FormTextAreaInput
            id='adjustment_reason'
            name='adjustment_reason'
            colSize='6'
            inputLabel='Adjustment Reason'
            className='mb-3'
            placeholder='Enter adjustment reason...'
            rows='6'
            value={values.adjustment_reason}
            handleTextAreaInput={handleChange}
            feedbackInvalid={errors?.adjustment_reason}
            invalid={errors?.adjustment_reason}
          />
        </CRow>
      )}
    </>
  )
}

export default AppForm
